import React, { useEffect,useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom"
import { useRbac } from "../../context"

import { 
  Building, 
  MapPin, 
  Mail, 
  Phone, 
  Briefcase, 
  Users, 
  DollarSign, 
  Calendar, 
  FileText,
  IndianRupee,
  Building2,
  Wallet,
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  MoreHorizontal,
  TrendingUp,
  Edit,
  Archive,
  ArchiveRestore,
  Trash2,
  UserPlus,
  Clock,
  ArrowRight,
  X,
  Search,
  Check,
  User,
  Bookmark,
  Globe
} from "lucide-react";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import {
  getCompanyProfile,
  getCompanyJobOpenings,
  getApplicationsByCompany,
  getCompanyEarnings,
  getApplicationsByCompanyExport
} from "../../services/companiesapi";
import { Card, CardContent } from "../../components/ui/card"; // Assuming Card component is available
import { Badge } from "../../components/ui/badge"; // Assuming Badge component is available
import { Button } from "../../components/ui/button"; // Assuming Button component is available
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "../../components/ui/dropdown-menu"; // Assuming DropdownMenu components are available
import { getAssignableUsers, deleteDraftJob, unassignUser, assignJob } from "../../services/jobsapi";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select"

interface CompanyProfile {
  id: string;
  name: string;
  email: string;
  phone: string;
  gstNo: string;
  registeredAddress: string;
  operationalAddress: string;
  spocDetails: Array<{
    name: string;
    email: string;
    phone: string;
  }>;
  logoUrl: string;
  summary: {
    totalOpenings: number;
    totalCandidatesInPipeline: number;
    totalPlacements: number;
    totalEarningsReceived: number;
    totalCommissionPayable: number;
  };
  brand: string;
  website: string
}

interface Job {
  id: string;
  title: string;
  status: string;
  location: string;
  employmentType: string;
  workType: string;
  noOfOpenings: number;
  createdAt: string;
  totalApplicants: number;
  activeApplicants: number;
  companyName: string;
  isArchived?: boolean;
}

interface Application {
  candidate: {
    id: string;
    name: string;
    fatherName: string;
    email: string;
    phone: string;
  };
  job: {
    id: string;
    title: string;
  };
  applicationId: string;
  companyLocation: string;
  currentStatus: string;
  interviewDate: string;
  joinedOrOfferedDate?: string;
  tenure: {
    status: string;
    daysLeft: number | null;
    isApproved?: boolean;
  };
  ledBy: {
    id: string;
    username: string;
  };
}

interface Earning {
  applicationId: string;
  candidateId: string;
  candidateName: string;
  email: string;
  phone: string;
  employeeId: string;
  positionName: string;
  salary: number;
  commissionReceived: number;
  companyLocation: string;
  lastInterviewDate: string;
  joiningDate: string;
}

interface ApiResponse<T> {
  status: string;
  data: T;
  page?: number;
  limit?: number;
  totalPages?: number;
  totalResults?: number;
  summary?: { totalEarningsReceived: number };
}
interface AssignableUser {
  id: string
  username: string
  name?: string
  email: string
  role: string
}
const CompanyDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate()
  const { user } = useRbac()
  const [lastAssignedCount, setLastAssignedCount] = useState<number | null>(null)
  const [assignableUsers, setAssignableUsers] = useState<AssignableUser[]>([])
  const [usersList, setUsersList] = useState<AssignableUser[]>([])
  const [alreadyAssignedUsers, setAlreadyAssignedUsers] = useState<AssignableUser[]>([])
  const [activeTab, setActiveTab] = useState<"details" | "jobs" | "applications" | "earnings">("details");
  const [companyProfile, setCompanyProfile] = useState<CompanyProfile | null>(null);
  const [jobs, setJobs] = useState<any>([]);
  const [statusFilter, setStatusFilter] = useState("published")
  const [applications, setApplications] = useState<Application[]>([]);
  const [applicationsSearchTerm, setApplicationsSearchTerm] = useState("");
  const applicationsSearchTimer = useRef<NodeJS.Timeout | null>(null)
  const applicationsSearchInputRef = useRef<HTMLInputElement | null>(null)
  const [applicationsDateFrom, setApplicationsDateFrom] = useState("")
  const [applicationsDateTo, setApplicationsDateTo] = useState("")
  const [applicationsDateError, setApplicationsDateError] = useState<string | null>(null)
  const [debouncedApplicationsSearch, setDebouncedApplicationsSearch] = useState("")
  const [applicationsStatus, setApplicationsStatus] = useState<string>("all")
  const [earnings, setEarnings] = useState<Earning[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [jobsPage, setJobsPage] = useState(1);
  const [applicationsPage, setApplicationsPage] = useState(1);
  const [earningsPage, setEarningsPage] = useState(1);
  const [jobsTotalPages, setJobsTotalPages] = useState(1);
  const [applicationsTotalPages, setApplicationsTotalPages] = useState(1);
  const [earningsTotalPages, setEarningsTotalPages] = useState(1);
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [logoError, setLogoError] = useState(false);
  const [userRole, setUserRole] = useState<string | null>(null)
  const [userSearchTerm, setUserSearchTerm] = useState("")
  const [filteredUsers, setFilteredUsers] = useState(usersList)
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [isSearchFocused, setIsSearchFocused] = useState(false)
  const [selectedUsers, setSelectedUsers] = useState<string[]>([])
  const [assigningJob, setAssigningJob] = useState(false)
  const [filterQuery, serFilterQuery] = useState({})

  
  
  
    
  
  const limit = 10;
  useEffect(() => {
    console.log("companyProfile",companyProfile)
  },[companyProfile])

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        toast.error("Company ID is missing");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const [profileRes, jobsRes, applicationsRes, earningsRes] = await Promise.all([
          getCompanyProfile(id),
          getCompanyJobOpenings(id, { page: jobsPage, limit }),
          getApplicationsByCompany(id, {
            page: applicationsPage,
            limit,
            search: debouncedApplicationsSearch || undefined,
            dateFrom: applicationsDateFrom || undefined,
            dateTo: applicationsDateTo || undefined,
            status: applicationsStatus !== "all" ? applicationsStatus : undefined,
          }),
          getCompanyEarnings(id, { page: earningsPage, limit }),
        ]);

        // Ensure proper data structure and handle logo URL
        const company = profileRes.data.company || {};
        
        // Transform the company data with proper fallbacks
        setCompanyProfile({
          ...company,
          id: company.id || '',
          name: company.name || '',
          email: company.email || '',
          phone: company.phone || '',
          gstNo: company.gstNo || '',
          registeredAddress: company.registeredAddress || '',
          operationalAddress: company.operationalAddress || '',
          logoUrl: company.logoUrl || '', // Handle empty logo URL gracefully
          spocDetails: Array.isArray(company.spocDetails) ? company.spocDetails : [],
          summary: {
            totalOpenings: company.summary?.totalOpenings || 0,
            totalCandidatesInPipeline: company.summary?.totalCandidatesInPipeline || 0,
            totalPlacements: company.summary?.totalPlacements || 0,
            totalEarningsReceived: company.summary?.totalEarningsReceived || 0,
            totalCommissionPayable: company.summary?.totalCommissionPayable || 0,
          }
        });

        setJobs(jobsRes.data.jobs || []);
        setJobsTotalPages(jobsRes.totalPages || 1);
        setApplications(applicationsRes.data.applications || []);
        setApplicationsTotalPages(applicationsRes.totalPages || 1);
        setEarnings(earningsRes.data.earnings || []);
        setEarningsTotalPages(earningsRes.totalPages || 1);
      } catch (err: any) {
        setError(err.message || "Failed to load company data");
        toast.error(err.message || "Failed to load company data");
        if (err.message.includes('logo')) {
          // Handle logo-specific errors
          console.warn('Logo loading failed:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, jobsPage, applicationsPage, earningsPage, debouncedApplicationsSearch, applicationsDateFrom, applicationsDateTo, applicationsStatus]);

  // Initialize from URL on mount
  useEffect(() => {
    const urlSearch = searchParams.get("search") || ""
    const urlFrom = searchParams.get("dateFrom") || ""
    const urlTo = searchParams.get("dateTo") || ""
    const urlStatus = searchParams.get("status") || "all"
    if (urlSearch) {
      setApplicationsSearchTerm(urlSearch)
      setDebouncedApplicationsSearch(urlSearch)
    }
    if (urlFrom) setApplicationsDateFrom(urlFrom)
    if (urlTo) setApplicationsDateTo(urlTo)
    if (urlStatus) setApplicationsStatus(urlStatus)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Debounce search term
  useEffect(() => {
    if (applicationsSearchTimer.current) clearTimeout(applicationsSearchTimer.current)
    applicationsSearchTimer.current = setTimeout(() => {
      setDebouncedApplicationsSearch(applicationsSearchTerm)
    }, 400)
    return () => {
      if (applicationsSearchTimer.current) clearTimeout(applicationsSearchTimer.current)
    }
  }, [applicationsSearchTerm])

  // Sync filters to URL (use debounced search to avoid frequent URL writes)
  useEffect(() => {
    const next = new URLSearchParams(searchParams)
    if (debouncedApplicationsSearch) next.set("search", debouncedApplicationsSearch)
    else next.delete("search")
    if (applicationsDateFrom) next.set("dateFrom", applicationsDateFrom)
    else next.delete("dateFrom")
    if (applicationsDateTo) next.set("dateTo", applicationsDateTo)
    else next.delete("dateTo")
    if (applicationsStatus && applicationsStatus !== "all") next.set("status", applicationsStatus)
    else next.delete("status")
    setSearchParams(next, { replace: true })
    // Ensure the search input keeps focus after URL update
    requestAnimationFrame(() => {
      applicationsSearchInputRef.current?.focus()
    })
  }, [debouncedApplicationsSearch, applicationsDateFrom, applicationsDateTo, applicationsStatus])

  useEffect(() => {
    if (!applicationsDateFrom || !applicationsDateTo) {
      setApplicationsDateError(null)
      return
    }
    const from = new Date(applicationsDateFrom)
    const to = new Date(applicationsDateTo)
    if (from > to) setApplicationsDateError("End date cannot be before start date.")
    else setApplicationsDateError(null)
  }, [applicationsDateFrom, applicationsDateTo])
  useEffect(() => {
    const term = userSearchTerm.toLowerCase()
    const filtered = usersList.filter(
      (user) =>
        user.username.toLowerCase().includes(term) ||
        user.email.toLowerCase().includes(term) ||
        user.role.toLowerCase().includes(term),
    )
    setFilteredUsers(filtered)
  }, [userSearchTerm, usersList])

  const handleApplicationsSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setApplicationsSearchTerm(value)
    // reset to page 1 on new search
    setApplicationsPage(1)
  }
  
  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "published": return "bg-emerald-100 text-emerald-700";
      case "draft": return "bg-amber-100 text-amber-700";
      case "closed": return "bg-rose-100 text-rose-700";
      default: return "bg-gray-100 text-gray-700";
    }
  };

  const getWorkTypeColor = (workType: string) => {
    switch (workType.toLowerCase()) {
      case "remote":
        return "bg-orange-50 text-orange-700 border-orange-200"
      case "hybrid":
        return "bg-blue-50 text-blue-700 border-blue-200"
      case "on-site":
        return "bg-orange-50 text-orange-700 border-orange-200"
      default:
        return "bg-gray-50 text-gray-700 border-gray-200"
    }
  }

  const getStatusBadgeColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "published": return "border-emerald-500 text-emerald-700";
      case "drafted": return "border-amber-500 text-amber-700";
      case "archived": return "border-gray-500 text-gray-700";
      default: return "border-gray-500 text-gray-700";
    }
  };

  const handleShareJob = (job: Job) => {
    // Placeholder for share job functionality
    console.log(`Sharing job: ${job.id}`);
  };

    const handleDeleteDraftJob = async (jobId: string, event?: React.MouseEvent) => {
    // Prevent default behavior and stop propagation
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    toast((t) => (
      <span>
        Are you sure you want to delete this draft job? This action cannot be undone.
        <br />
        <button
          type="button" // Explicitly set to button to avoid form submission
          style={{
            marginRight: 8,
            padding: "4px 12px",
            background: "#EC6E51",
            color: "white",
            borderRadius: 4,
            border: "none",
          }}
          onClick={async (e) => {
            e.preventDefault()
            e.stopPropagation()
            toast.dismiss(t.id)
            try {
              const token = localStorage.getItem("adminToken") || ""
              await deleteDraftJob(jobId, token)
              setJobs((prevJobs:any) => prevJobs.filter((job:any) => job.id !== jobId))
              toast.success("Draft job deleted successfully!")
            } catch (error: any) {
              console.error("Failed to delete draft job:", error)
              toast.error(error.message || "Failed to delete draft job. Please try again.")
            }
          }}
        >
          Delete
        </button>
        <button
          type="button" // Explicitly set to button
          style={{
            padding: "4px 12px",
            background: "#eee",
            color: "#333",
            borderRadius: 4,
            border: "none",
          }}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            toast.dismiss(t.id)
          }}
        >
          Cancel
        </button>
      </span>
    ),
    {
      duration: Infinity, // Keep toast open until user interacts
    })
  }

  const handleEditJob = (job: Job) => {
    // Placeholder for edit job functionality
    console.log(`Editing job: ${job.id}`);
  };

    const handleUserToggle = (userId: string) => {
    setSelectedUsers((prev) => (prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]))
  }

  const handleArchiveJob = (jobId: string, unarchive: boolean) => {
    // Placeholder for archive/unarchive job functionality
    console.log(`${unarchive ? "Unarchiving" : "Archiving"} job: ${jobId}`);
  };

  const handleDeleteJob = (jobId: string) => {
    // Placeholder for delete job functionality
    console.log(`Deleting job: ${jobId}`);
  };

  const handleViewJobDetails = async (jobId: string) => {
    navigate(`/viewdetails/${jobId}`)
  }

const getSelectedUserNames = () => {
    return selectedUsers
      .map((id) => {
        const user = usersList.find((u) => u.id === id)
        return user?.username
      })
      .filter((username): username is string => !!username)
  }
const handleAssignJob = async () => {
  if (!selectedJob) {
    toast.error("Please select at least one user to assign the job.")
    return
  }

  try {
    setAssigningJob(true)
    
    const response = await assignJob(selectedJob.id, { assignToUserIds: selectedUsers })
    if (response && response.data && response.data.assignedTo) {
      const assignedWithEmail = response.data.assignedTo.map((user: any) => ({
        ...user,
        email: user.email || "",
      }))
      setAlreadyAssignedUsers(assignedWithEmail)
    }
    
    const count = selectedUsers.length
    setLastAssignedCount(count)
    console.log("Assigned count (frontend):", count)
    setDialogOpen(false)
    
    const assignedNames = getSelectedUserNames().join(", ")
    toast.success(`Job assigned successfully to ${assignedNames}`)
    setSelectedUsers([])
    if (id) {
  getCompanyJobOpenings(id, { page: jobsPage, limit }).then(() => {
    // Handle success
  }).catch((error) => {
    // Handle error
    toast.error("Failed to assign job. Please try again.")

  });
}
  } catch (error) {
    console.error("Failed to assign job:", error)
    toast.error("Failed to assign job. Please try again.")
  } finally {
    setAssigningJob(false)
  }
}

  const renderPagination = (currentPage: number, totalPages: number, setPage: (page: number) => void) => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="flex items-center justify-end gap-2 mt-4 bg-white sticky bottom-0 py-[10px]">
        <button
          onClick={() => setPage(currentPage - 1)}
          disabled={currentPage === 1}
          className={`p-2 rounded-full ${
            currentPage === 1 ? "text-gray-300 cursor-not-allowed" : "text-orange-600 hover:bg-orange-50"
          }`}
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        {startPage > 1 && (
          <>
            <button
              onClick={() => setPage(1)}
              className={`px-3 py-1 text-sm font-medium rounded-lg ${
                currentPage === 1 ? "bg-orange-600 text-white" : "text-gray-600 hover:bg-orange-50"
              }`}
            >
              1
            </button>
            {startPage > 2 && <span className="text-gray-600">...</span>}
          </>
        )}
        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => setPage(page)}
            className={`px-3 py-1 text-sm font-medium rounded-lg ${
              currentPage === page ? "bg-orange-600 text-white" : "text-gray-600 hover:bg-orange-50"
            }`}
          >
            {page}
          </button>
        ))}
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="text-gray-600">...</span>}
            <button
              onClick={() => setPage(totalPages)}
              className={`px-3 py-1 text-sm font-medium rounded-lg ${
                currentPage === totalPages ? "bg-orange-600 text-white" : "text-gray-600 hover:bg-orange-50"
              }`}
            >
              {totalPages}
            </button>
          </>
        )}
        <button
          onClick={() => setPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`p-2 rounded-full ${
            currentPage === totalPages ? "text-gray-300 cursor-not-allowed" : "text-orange-600 hover:bg-orange-50"
          }`}
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-orange-600 mx-auto"></div>
          <p className="text-gray-600 font-semibold">Loading company details...</p>
        </div>
      </div>
    );
  }

  if (error || !companyProfile) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-bold text-gray-900">Company Not Found</h2>
          <p className="text-gray-600">The company you're looking for doesn't exist or an error occurred.</p>
        </div>
      </div>
    );
  }

  const handleRemoveUser = (userId: string) => {
    handleUserToggle(userId)
  }
 const fetchAssignableUsers = async (jobId: string) => {
    if (!jobId) return

    try {
      const response = await getAssignableUsers(jobId)
      if (response.status === "success") {
        // Set assignable users
        if (response.data?.availableToAssign) {
          setAssignableUsers(response.data.availableToAssign)
          setUsersList(response.data.availableToAssign)
        } else {
          setAssignableUsers([])
          setUsersList([])
        }

        // Set already assigned users from the same response
        if (response.data?.assignedUsers) {
          setAlreadyAssignedUsers(response.data.assignedUsers)
        } else {
          setAlreadyAssignedUsers([])
        }
      } else {
        console.warn("Unexpected response structure:", response)
        setAssignableUsers([])
        setAlreadyAssignedUsers([])
      }
    } catch (error) {
      console.error("Failed to fetch assignable users:", error)
      setAssignableUsers([])
      setAlreadyAssignedUsers([])
      toast.error("Failed to load assignable users. Please try again.")
    }
  }
  const handleUnassignUser = async (userId:string,jobId:string)=>{
  console.log(selectedJob)
  if(!userId || !jobId){
    throw toast.error("Please select a user and a job")
  }
    try{
    await unassignUser(userId,jobId)
    toast.success("User unassigned successfully!")
    if (id) {
  getCompanyJobOpenings(id, { page: jobsPage, limit }).then(() => {
    // Handle success
  }).catch((error) => {
    // Handle error
    toast.error("Failed to unassign user. Please try again.")

  });
}

  }catch(error){
    console.error("Failed to unassign user:", error)
    toast.error("Failed to unassign user. Please try again.")
  }
  fetchAssignableUsers(jobId)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="flex flex-col sticky top-0 z-10">
        <div className="bg-white shadow-sm border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-col md:flex-row items-start gap-6">
              <div className="flex-1 space-y-4">
                <div className="flex flex-wrap md:flex-nowrap items-center justify-start gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <button
                    onClick={() => window.history.back()}
                    className="p-2 rounded-full text-orange-600 hover:bg-orange-50 transition-all duration-200"
                    aria-label="Go back"
                  >
                    <ArrowLeft className="h-6 w-6" />
                  </button>
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-wrap md:flex-nowrap items-center justify-end gap-3 w-full md:w-auto mt-2 md:mt-0">
                      {!logoError && companyProfile.logoUrl ? (
                        <img
                          src={companyProfile.logoUrl}
                          alt={`${companyProfile.name} logo`}
                          className="h-12 w-12 object-contain rounded-full border border-gray-200"
                          onError={() => {
                            setLogoError(true);
                            // Log the error for debugging
                            console.warn('Failed to load company logo:', companyProfile.logoUrl);
                          }}
                        />
                      ) : (
                        <div className="h-12 w-12 rounded-full border border-gray-200 bg-gray-50 flex items-center justify-center">
                          <Building2 className="h-6 w-6 text-gray-400" />
                        </div>
                      )}
                      <h1 className="text-3xl md:text-4xl font-bold text-gray-900">{companyProfile.brand}</h1>
                    </div>
                    <p className="text-lg font-semibold text-gray-600">{companyProfile.email}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="bg-white border-b border-gray-100 shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex relative">
              <button
                onClick={() => setActiveTab("details")}
                className={`relative flex items-center justify-center gap-2 py-4 px-6 text-sm font-medium rounded-t-lg transition-all duration-300 flex-1 ${
                  activeTab === "details"
                    ? "text-orange-600 border-b-2 border-orange-600 bg-orange-50"
                    : "text-gray-600 hover:text-orange-600 hover:bg-orange-50/50"
                }`}
                style={{ outline: "none", outlineOffset: "0" }}
              >
                <Building2 className="w-5 h-5" />
                Company profile
              </button>
              <button
                onClick={() => setActiveTab("jobs")}
                className={`relative flex items-center justify-center gap-2 py-4 px-6 text-sm font-medium rounded-t-lg transition-all duration-300 flex-1 ${
                  activeTab === "jobs"
                    ? "text-orange-600 border-b-2 border-orange-600 bg-orange-50"
                    : "text-gray-600 hover:text-orange-600 hover:bg-orange-50/50"
                }`}
                style={{ outline: "none", outlineOffset: "0" }}
              >
                <Briefcase className="w-5 h-5" />
                Job Openings
              </button>
              <button
                onClick={() => setActiveTab("applications")}
                className={`relative flex items-center justify-center gap-2 py-4 px-6 text-sm font-medium rounded-t-lg transition-all duration-300 flex-1 ${
                  activeTab === "applications"
                    ? "text-orange-600 border-b-2 border-orange-600 bg-orange-50"
                    : "text-gray-600 hover:text-orange-600 hover:bg-orange-50/50"
                }`}
                style={{ outline: "none", outlineOffset: "0" }}
              >
                <Users className="w-5 h-5" />
                Applications
              </button>
              <button
                onClick={() => setActiveTab("earnings")}
                className={`relative flex items-center justify-center gap-2 py-4 px-6 text-sm font-medium rounded-t-lg transition-all duration-300 flex-1 ${
                  activeTab === "earnings"
                    ? "text-orange-600 border-b-2 border-orange-600 bg-orange-50"
                    : "text-gray-600 hover:text-orange-600 hover:bg-orange-50/50"
                }`}
                style={{ outline: "none", outlineOffset: "0" }}
              >
                <Wallet className="w-5 h-5" />
                Company Earnings
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-2 sm:px-3 lg:px-4 py-4">
        {activeTab === "details" && (
          <div className="space-y-6">
            {/* Company Profile */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-xl font-semibold text-orange-600 flex items-center gap-2 mb-4">
                <Building className="w-5 h-5" />
                Company Profile
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex flex-wrap md:flex-nowrap items-center  gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <Bookmark className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">Legal Name:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.name}</span>
                  </div>
                  <div className="flex flex-wrap md:flex-nowrap items-center gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <Mail className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">Email:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.email}</span>
                  </div>
                  <div className="flex flex-wrap md:flex-nowrap items-center gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <Phone className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">Phone:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.phone}</span>
                  </div>
                  <div className="flex flex-wrap md:flex-nowrap items-center gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <FileText className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">GST Number:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.gstNo}</span>
                  </div>
                  <div className="flex flex-wrap md:flex-nowrap items-center gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <Globe className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">Website:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.website}</span>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex flex-wrap md:flex-nowrap items-center gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <MapPin className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">Registered Address:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.registeredAddress}</span>
                  </div>
                  <div className="flex flex-wrap md:flex-nowrap items-center gap-3 w-full md:w-auto mt-2 md:mt-0">
                    <MapPin className="w-5 h-5 text-gray-500" />
                    <span className="text-sm font-medium text-gray-600">Operational Address:</span>
                    <span className="text-sm font-semibold text-gray-900">{companyProfile.operationalAddress}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* SPOC Details */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-xl font-semibold text-orange-600 flex items-center gap-2 mb-4">
                <Users className="w-5 h-5" />
                SPOC Details
              </h3>
              {Array.isArray(companyProfile.spocDetails) && companyProfile.spocDetails.length > 0 ? (
                <div className="space-y-4">
                  {companyProfile.spocDetails.map((spoc, idx) => (
                    <div key={idx} className="border-l-4 border-orange-600 pl-4">
                      <p className="text-sm font-semibold text-gray-900">{spoc.name}</p>
                      <p className="text-sm text-gray-600">Email: {spoc.email}</p>
                      <p className="text-sm text-gray-600">Phone: {spoc.phone}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500">No SPOC details available.</p>
              )}
            </div>

            {/* Summary */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-xl font-semibold text-orange-600 flex items-center gap-2 mb-4">
                <FileText className="w-5 h-5" />
                Performance Overview
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="flex flex-wrap md:flex-nowrap items-center justify-start gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <Briefcase className="w-5 h-5 text-gray-500" />
                  <span className="text-sm font-medium text-gray-600">Total Openings:</span>
                  <span className="text-sm font-semibold text-gray-900">{companyProfile.summary.totalOpenings}</span>
                </div>
                <div className="flex flex-wrap md:flex-nowrap items-center justify-start gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <Users className="w-5 h-5 text-gray-500" />
                  <span className="text-sm font-medium text-gray-600">Candidates in Pipeline:</span>
                  <span className="text-sm font-semibold text-gray-900">{companyProfile.summary.totalCandidatesInPipeline}</span>
                </div>
                <div className="flex flex-wrap md:flex-nowrap items-center justify-start gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <Users className="w-5 h-5 text-gray-500" />
                  <span className="text-sm font-medium text-gray-600">Total Placements:</span>
                  <span className="text-sm font-semibold text-gray-900">{companyProfile.summary.totalPlacements}</span>
                </div>
                <div className="flex flex-wrap md:flex-nowrap items-center justify-start gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <IndianRupee className="w-5 h-5 text-gray-500" />
                  <span className="text-sm font-medium text-gray-600">Total Earnings:</span>
                  <span className="text-sm font-semibold text-gray-900">₹{companyProfile.summary.totalEarningsReceived.toLocaleString()}</span>
                </div>
                <div className="flex flex-wrap md:flex-nowrap items-center justify-start gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <IndianRupee className="w-5 h-5 text-gray-500" />
                  <span className="text-sm font-medium text-gray-600">Commission Payable:</span>
                  <span className="text-sm font-semibold text-gray-900">₹{companyProfile.summary.totalCommissionPayable.toLocaleString()}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "jobs" && (
          <div className="space-y-6">
            {/* Job Openings */}
            <div className="rounded-xl shadow-sm">
             
              {jobs.length > 0 ? (
                 <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
              {jobs.map((job:any) => (
                <Card
                  key={job.id}
                  className="group bg-white border-0 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 rounded-2xl overflow-hidden"
                >
                  <CardContent className="flex flex-col justify-between h-full p-0">
                    <div className="flex flex-col gap-4 p-6 pb-0">
                      <div className="flex items-center justify-between">

                        <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
                          <Badge
                            variant="outline"
                            className={`text-xs font-semibold px-3 py-1.5 rounded-full border ${getStatusBadgeColor(job.status)}`}
                          >
                            {job.status === "published" ? "Published" : job.status === "drafted" ? "Draft" : "Archived"}
                          </Badge>
                         
                        </div>

                        <div className="">
                          {job.status === "published" && user?.role?.toLowerCase() !== "master_bde" && (
                            <div className="inline-flex items-center">
                              {/* <div
                                className="rounded-full text-black text-xs bg-accent font-bold flex items-center justify-center transition-colors duration-200 border border-input hover:text-accent-foreground"
                                style={{ width: 36, height: 36 }}
                              >
                                {selectedJob?.id === job.id && lastAssignedCount !== null
                                  ? lastAssignedCount
                                  : (job.assignedUserCount ?? 0)}
                              </div> */}

                              <Button
                                variant="outline"
                                size="sm"
                                className="text-xs font-medium rounded-full h-auto bg-accent p-[10px] min-w-[16px] min-h-[16px] -ml-2.5 hover:bg-orange-600  text-orange-500 hover:text-white"
                                onClick={async () => {
                                  try {
                                    setSelectedJob(job)
                                    setDialogOpen(true)
                                    setLastAssignedCount(null)
                                    
                                    if (!job.id) {
                                      console.error("Job ID is undefined or invalid")
                                      toast.error("Invalid job ID. Please try again.")
                                      return
                                    }

                                    console.log("Fetching assignable users for job ID:", job.id)
                                    await fetchAssignableUsers(job.id)
                                    
                                  } catch (error) {
                                    console.error("Error in dialog open handler:", error)
                                    toast.error("Failed to load job data. Pleas e try again.")
                                  }
                                }}
                              >
                                <UserPlus className="w-[13px] cursor-pointer" />
                              </Button>
                            </div>
                          )}
                          {userRole?.toLowerCase() === "admin" && (
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <Button
                                variant="ghost"
                                size="icon"
                                className="h-8 w-8 hover:bg-gray-50 rounded-full transition-colors duration-200"
                              >
                                <MoreHorizontal className="h-4 w-4 text-gray-500" />
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end" className="w-48">
                              <DropdownMenuItem onClick={() => handleEditJob(job)}>
                                <Edit className="mr-2 h-4 w-4" />
                                {job.status.toLowerCase() === "drafted" ? "Resume" : "Edit"}
                              </DropdownMenuItem>
                              {statusFilter === "archived" || job.isArchived ? (
                                <DropdownMenuItem onClick={() => handleArchiveJob(job.id, true)}>
                                  <ArchiveRestore className="mr-2 h-4 w-4" />
                                  Unarchive
                                </DropdownMenuItem>
                              ) : (
                                <DropdownMenuItem onClick={() => handleArchiveJob(job.id, false)}>
                                  <Archive className="mr-2 h-4 w-4" />
                                  Archive
                                </DropdownMenuItem>
                              )}
                              {job.status.toLowerCase() === "drafted" && (
                                <DropdownMenuItem
                                  className="text-red-600 focus:text-red-600"
                                  onSelect={(e) => e.preventDefault()} // Prevent default DropdownMenuItem behavior
                                >
                                  <button
                                    type="button"
                                    style={{
                                      background: "none",
                                      border: "none",
                                      padding: 0,
                                      margin: 0,
                                      color: "inherit",
                                      font: "inherit",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                    onClick={() => handleDeleteDraftJob(job.id)} // Pass the event to handleDeleteDraftJob
                                  >
                                    <Trash2 className="mr-2 h-4 w-4" />
                                    Delete
                                  </button>
                                </DropdownMenuItem>
                              )}
                            </DropdownMenuContent>
                          </DropdownMenu>
                          )}
                        </div>
                      </div>

                      <div className="space-y-3">
                        <h3 className="text-lg font-bold text-gray-900 line-clamp-2 leading-tight group-hover:text-[#EC6E51] transition-colors duration-200">
                          {job.title}
                        </h3>
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Building2 className="h-4 w-4 text-gray-400" />
                          <span className="font-medium">{job.companyName}</span>
                        </div>
                      </div>

                       <div className="flex flex-col gap-2">
                           <Badge
                              variant="outline"
                              className="text-xs font-medium px-2 py-1 rounded-md bg-gray-50 text-gray-700 border-gray-200"
                              style={{maxWidth:"100%"}}
                            >
                            <div> <MapPin className="h-[13px] w-[13px] mr-1" /></div>
                              <div className="truncate">
                              {job.location}
                              </div>
                            </Badge>
                            <div className="flex gap-2">
                          {job.employmentType && (
                            <Badge
                              variant="outline"
                              className="text-sm font-medium px-3 py-1.5 rounded-md bg-gray-50 text-gray-700 border-gray-200 flex items-center gap-1"
                              style={{width:"62%"}}
                            >
                              <Clock className="h-4 w-4" />
                              <div className="truncate">
              
                              {job.employmentType}</div>
                            </Badge>
                          )}
                            <Badge
                              variant="outline"
                              className={`text-xs font-medium px-2 py-1 rounded-md ${getWorkTypeColor(job.workType)}`}
                            >
                              <Briefcase className="h-3 w-3 mr-1" />
                              {job.workType}
                            </Badge>
                            </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4">
                          <div className="flex justify-between items-center gap-4">
                            <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
                              <span className="text-sm text-gray-600">Openings:</span>
                              <span className="text-sm font-bold text-gray-900">{job.noOfOpenings}</span>
                            </div>
                            <div className="flex items-center gap-1 text-sm text-gray-600">
                              <Calendar className="h-4 w-4 text-[#EC6E51]" />
                              <span>{formatDate(job.createdAt)}</span>
                            </div>
                          </div>
                         
                      </div>
                      <div className="flex flex gap-2 w-full">
                      <Badge
                          variant="outline"
                          className={`w-full text-xs font-medium px-2 py-2 rounded-md bg-gray-50 text-gray-700 justify-center`}
                        >
                      
                          {job.commissionType === "fixed" ? "Fixed" : "Percentage"}
                          
                        </Badge>
                        <Badge
                          variant="outline"
                          className={`w-full text-xs font-medium px-2 py-2 rounded-md bg-gray-50 text-gray-700 justify-center`}
                        >
                      
                          {job.commissionType === "fixed" ? `₹ ${job.commissionAmount}` : `${job.commissionAmount}%`}
                          
                        </Badge>

                        <Badge
                          variant="outline"
                          className={`w-full text-xs font-medium px-2 py-2 rounded-md bg-gray-50 text-gray-700 justify-center`}
                        >
                        
                          {job.commissionType === "fixed"
                        ? `₹ ${((job.commissionAmount / 100) * 70).toFixed(2)}`
                        : `${((job.commissionAmount / 100) * 50).toFixed(2)}%`}
                        </Badge>
                      </div>

                      </div>
                      <div className="p-6 py-4">
                        <Button
                          variant="ghost"
                          size="sm"
                          className="w-full text-[#EC6E51] hover:text-white hover:bg-[#EC6E51] font-medium px-4 py-2 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 border border-[#EC6E51] hover:border-transparent"
                          onClick={() => handleViewJobDetails(job.id)}
                        >
                          View Details
                          <ArrowRight className="h-4 w-4" />
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
              ))}
            </div>
              ) : (
                <p className="text-gray-500">No job openings available.</p>
              )}
              {jobsTotalPages > 1 && renderPagination(jobsPage, jobsTotalPages, setJobsPage)}
            </div>
          </div>
        )}

        {activeTab === "applications" && (
          <div className="space-y-6">
            {/* Applications */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-xl font-semibold text-orange-600 flex items-center gap-2 mb-4">
                <Users className="w-5 h-5" />
                Applications
              </h3>
              <div className="flex flex-wrap md:flex-nowrap items-start justify-between gap-3 mb-4">
                {/* Left group: filters */}
                <div className="flex flex-wrap items-center gap-3 flex-1 min-w-0">
                  <div className="relative w-full sm:max-w-sm flex-1">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search applications..."
                    value={applicationsSearchTerm}
                    onChange={handleApplicationsSearchChange}
                      ref={applicationsSearchInputRef}
                    className="w-full pl-10 pr-10 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400 transition-all duration-200"
                  />
                  {applicationsSearchTerm && (
                    <button
                      type="button"
                      onClick={() => setApplicationsSearchTerm("")}
                      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      aria-label="Clear search"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                  </div>
                  <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
                  <input
                    type="date"
                    value={applicationsDateFrom}
                    onChange={(e) => {
                      setApplicationsDateFrom(e.target.value)
                      setApplicationsPage(1)
                    }}
                    max={applicationsDateTo || undefined}
                    className="w-full sm:w-40 h-10 rounded-lg border border-gray-200 bg-white px-2 text-sm focus:ring-2 focus:ring-orange-200 focus:border-orange-400"
                    title="From Date"
                  />
                  <input
                    type="date"
                    value={applicationsDateTo}
                    onChange={(e) => {
                      setApplicationsDateTo(e.target.value)
                      setApplicationsPage(1)
                    }}
                    min={applicationsDateFrom || undefined}
                    className="w-full sm:w-40 h-10 rounded-lg border border-gray-200 bg-white px-2 text-sm focus:ring-2 focus:ring-orange-200 focus:border-orange-400"
                    title="To Date"
                  />
                  </div>
                  <div className="w-full sm:w-[180px]">
                  <Select
                    value={applicationsStatus}
                    onValueChange={(v) => {
                      setApplicationsStatus(v)
                      setApplicationsPage(1)
                    }}
                  >
                    <SelectTrigger className="w-full h-10 rounded-lg border-gray-200 focus:ring-2 focus:ring-orange-500">
                      <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 w-full sm:w-auto">
                        <SelectValue placeholder="All Status" />
                      </div>
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Status</SelectItem>
                      <SelectItem value="Applied">Applied</SelectItem>
                      <SelectItem value="Interview Scheduled">Interview Scheduled</SelectItem>
                      <SelectItem value="Interview Rescheduled">Interview Rescheduled</SelectItem>
                      <SelectItem value="Selected">Selected</SelectItem>
                      <SelectItem value="Offered">Offered</SelectItem>
                      <SelectItem value="Joined">Joined</SelectItem>
                      <SelectItem value="Rejected by Company">Rejected by Company</SelectItem>
                      <SelectItem value="Tenure Rejected">Tenure Rejected</SelectItem>
                    </SelectContent>
                  </Select>
                  </div>
                </div>

                {/* Right group: download + count */}
                <div className="flex flex-wrap md:flex-nowrap items-center justify-end gap-3 w-full md:w-auto mt-2 md:mt-0">
                  <Button
                    variant="outline"
                    onClick={async () => {
                    try {
                      toast.loading("Preparing Excel...", { id: "export-company-apps" })

                        const hasAnyFilter = Boolean(
                          applicationsSearchTerm || applicationsDateFrom || applicationsDateTo || (applicationsStatus && applicationsStatus !== "all")
                        )

                        const rows: any[] = []
                       
                        if (!id) {
                          toast.error("Company ID is missing");
                          setLoading(false);
                          return;
                        }
                        const res = await getApplicationsByCompanyExport(id, {
                          page: 1,
                          limit,
                          search: debouncedApplicationsSearch || undefined,
                            dateFrom: applicationsDateFrom || undefined,
                            dateTo: applicationsDateTo || undefined,
                            status: applicationsStatus !== "all" ? applicationsStatus : undefined,
                          })

                      res?.data?.applications.forEach((app: any) => {
                          rows.push({
                            Candidate: app?.candidate?.name || "",
                            Email: app?.candidate?.email || "",
                            Phone: app?.candidate?.phone || "",
                            JobTitle: app?.job?.title || "",
                            Status: app?.currentStatus || app?.currentStatus?.status || "",
                            CompanyLocation: app?.companyLocation || "",
                            InterviewDate: app?.interviewDate || "",
                            JoinedOrOfferedDate: app?.joinedOrOfferedDate || "",
                            LedBy: app?.ledBy?.username || "",
                          })
                        })
                        const worksheet = XLSX.utils.json_to_sheet(rows)
                        const workbook = XLSX.utils.book_new()
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Applications")
                        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" })
                        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement("a")
                        link.href = url
                        link.setAttribute("download", `company_${id || "apps"}_applications.xlsx`)
                        document.body.appendChild(link)
                        link.click()
                        link.parentNode?.removeChild(link)
                        window.URL.revokeObjectURL(url)
                        toast.success("Excel downloaded", { id: "export-company-apps" })
                      } catch (err: any) {
                        console.error("Export failed:", err)
                        toast.error(err?.message || "Failed to export", { id: "export-company-apps" })
                      }
                    }}
                    className="flex items-center gap-2 rounded-lg border-orange-300 text-orange-600 hover:bg-orange-50 w-full sm:w-auto"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                    </svg>
                    Download Excel
                  </Button>
                  <span className="text-sm text-gray-500 whitespace-nowrap">
                    {applications.length} results
                  </span>
                </div>
              </div>
              {applicationsDateError && (
                <p className="text-sm text-red-600 -mt-2 mb-2">{applicationsDateError}</p>
              )}
              {(applicationsSearchTerm || applicationsDateFrom || applicationsDateTo || applicationsStatus !== "all") && (
                <div className="flex flex-wrap items-center gap-2 mt-2">
                  {applicationsSearchTerm && (
                    <Badge variant="secondary" className="flex items-center gap-2">
                      Search: <span className="font-medium">{applicationsSearchTerm}</span>
                      <button
                        type="button"
                        onClick={() => {
                          setApplicationsSearchTerm("")
                          setApplicationsPage(1)
                        }}
                        className="ml-1 text-gray-500 hover:text-gray-700"
                        aria-label="Clear search filter"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </Badge>
                  )}
                  {applicationsDateFrom && (
                    <Badge variant="secondary" className="flex items-center gap-2">
                      From: <span className="font-medium">{applicationsDateFrom}</span>
                      <button
                        type="button"
                        onClick={() => {
                          setApplicationsDateFrom("")
                          setApplicationsPage(1)
                        }}
                        className="ml-1 text-gray-500 hover:text-gray-700"
                        aria-label="Clear from date"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </Badge>
                  )}
                  {applicationsDateTo && (
                    <Badge variant="secondary" className="flex items-center gap-2">
                      To: <span className="font-medium">{applicationsDateTo}</span>
                      <button
                        type="button"
                        onClick={() => {
                          setApplicationsDateTo("")
                          setApplicationsPage(1)
                        }}
                        className="ml-1 text-gray-500 hover:text-gray-700"
                        aria-label="Clear to date"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </Badge>
                  )}
                  {applicationsStatus !== "all" && (
                    <Badge variant="secondary" className="flex items-center gap-2">
                      Status: <span className="font-medium">{applicationsStatus}</span>
                      <button
                        type="button"
                        onClick={() => {
                          setApplicationsStatus("all")
                          setApplicationsPage(1)
                        }}
                        className="ml-1 text-gray-500 hover:text-gray-700"
                        aria-label="Clear status filter"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </Badge>
                  )}
                  <button
                    type="button"
                    onClick={() => {
                      setApplicationsSearchTerm("")
                      setApplicationsDateFrom("")
                      setApplicationsDateTo("")
                      setApplicationsStatus("all")
                      setApplicationsPage(1)
                    }}
                    className="text-xs text-orange-600 hover:underline ml-1"
                  >
                    Clear all
                  </button>
                </div>
              )}
              {applications.length > 0 ? (
                <>
                <div className="overflow-x-auto">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="text-sm font-semibold text-gray-600 border-b border-gray-200">
                        <th className="py-3 px-4">Candidate</th>
                        <th className="py-3 px-4">Job Title</th>
                        <th className="py-3 px-4">Status</th>
                        <th className="py-3 px-4">Location</th>
                        <th className="py-3 px-4">Interview Date</th>
                        <th className="py-3 px-4">Joined/Offered</th>
                        <th className="py-3 px-4">Led By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {applications.map((app) => (
                        <tr key={app.applicationId} className="border-b border-gray-100 hover:bg-gray-50">
                          <td className="py-3 px-4 text-sm font-medium text-gray-900">
                            {app.candidate.name} ({app.candidate.email})
                          </td>
                          <td className="py-3 px-4 text-sm text-gray-600">{app.job.title}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{app.currentStatus}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{app.companyLocation}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{app.interviewDate ? (formatDate(app.interviewDate) ||  "N/A"): "N/A"}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">
                            {app.joinedOrOfferedDate ? formatDate(app.joinedOrOfferedDate) : "N/A"}
                          </td>
                          <td className="py-3 px-4 text-sm text-gray-600">{app?.ledBy?.username}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                  {applicationsTotalPages > 1 && renderPagination(applicationsPage, applicationsTotalPages, setApplicationsPage)}
                      </>
                ) : (
                <p className="text-gray-500 mt-4">No applications available.</p>
              )}
            </div>
          </div>
        )}

        {activeTab === "earnings" && (
          <div className="space-y-6">
            {/* Earnings */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-xl font-semibold text-orange-600 flex items-center gap-2 mb-4">
                <IndianRupee className="w-5 h-5" />
                Company Earnings
              </h3>
              {earnings.length > 0 ? (
                <>
                <div className="overflow-x-auto">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="text-sm font-semibold text-gray-600 border-b border-gray-200">
                        <th className="py-3 px-4">Candidate</th>
                        <th className="py-3 px-4">Position</th>
                        <th className="py-3 px-4">Employee ID</th>
                        <th className="py-3 px-4">Salary</th>
                        <th className="py-3 px-4">Commission</th>
                        <th className="py-3 px-4">Location</th>
                        <th className="py-3 px-4">Interview Date</th>
                        <th className="py-3 px-4">Joining Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {earnings.map((earning) => (
                        <tr key={earning.applicationId} className="border-b border-gray-100 hover:bg-gray-50">
                          <td className="py-3 px-4 text-sm font-medium text-gray-900">
                            {earning.candidateName} ({earning.email})
                          </td>
                          <td className="py-3 px-4 text-sm text-gray-600">{earning.positionName}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{earning.employeeId}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">₹{earning.salary.toLocaleString()}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">₹{earning.commissionReceived.toLocaleString()}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{earning.companyLocation}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{formatDate(earning.lastInterviewDate)}</td>
                          <td className="py-3 px-4 text-sm text-gray-600">{formatDate(earning.joiningDate)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                  {earningsTotalPages > 1 && renderPagination(earningsPage, earningsTotalPages, setEarningsPage)}
                  </>
              ) : (
                <p className="text-gray-500">No earnings data available.</p>
              )}
            </div>
          </div>
        )}
      </div>
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
              <DialogContent className="max-w-xl p-0 max-h-[85vh] overflow-hidden flex flex-col gap-0">
                <div className="bg-white rounded-3xl shadow-2xl w-full flex flex-col max-h-[85vh] overflow-hidden">
                  <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-100 shrink-0">
                    <DialogHeader className="pr-8 space-y-1">
                      <DialogTitle className="text-lg sm:text-xl font-bold text-gray-900 line-clamp-2">
                        Assign <span className="text-orange-600">{selectedJob?.title}</span> Job
                      </DialogTitle>
                      <DialogDescription className="text-sm text-gray-500">
                        Select team members to assign this job
                      </DialogDescription>
                    </DialogHeader>
                  </div>
      
                  <div className="px-4 sm:px-6 py-4 space-y-4 transition-all duration-300 overflow-y-auto flex-1 min-h-0">
                    {alreadyAssignedUsers.length > 0 && (
                      <div className="">
                        <label className="text-sm font-medium text-gray-700 mb-3">Already Assigned</label>
                        <div className="flex flex-wrap gap-2 mt-3 max-h-28 overflow-y-auto">
                          {alreadyAssignedUsers.map((user) => (
                            <div
                              key={user.id}
                              className="flex items-center bg-green-100 text-green-700 text-xs font-medium px-2.5 py-1 rounded-full"
                            >
                              <span>{user.name || user.username}</span>
                              <button className="text-orange" onClick={() => handleUnassignUser(user.id, selectedJob?.id ? selectedJob?.id : "")}>
                                <X className="h-4 w-4" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
      
                
                    {/* Team Members Search and Selection */}
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-gray-700">Team Members</label>
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                          type="text"
                          placeholder="Search by name or email..."
                          value={userSearchTerm}
                          onChange={(e) => setUserSearchTerm(e.target.value)}
                          className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400 transition-all duration-200"
                          ref={inputRef}
                        />
                      </div>
                    </div>
      
                    {(isSearchFocused || userSearchTerm.length > 0) && (
                      <div className="border border-gray-200 rounded-2xl max-h-[min(240px,35vh)] overflow-y-auto bg-white">
                        {filteredUsers.length > 0 ? (
                          filteredUsers.map((user) => (
                            <div
                              key={user.id}
                              onClick={() => handleUserToggle(user.id)}
                              className="flex items-center p-3 hover:bg-orange-50 cursor-pointer transition-colors duration-150 border-b border-gray-100 last:border-b-0"
                            >
                              <div className="w-10 h-10 bg-gradient-to-br from-gray-400 to-orange-500 rounded-full flex items-center justify-center text-white font-medium text-lg mr-4">
                                {user.username.charAt(0).toUpperCase()}
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-gray-900 truncate">{user.username}</p>
                                <p className="text-xs text-gray-500 truncate">
                                  {user.email} • {user.role}
                                </p>
                              </div>
                              <div
                                className={`w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all duration-200 ${
                                  selectedUsers.includes(user.id)
                                    ? "bg-orange-500 border-orange-500"
                                    : "border-gray-300 bg-gray-50 group-hover:border-orange-400"
                                }`}
                              >
                                {selectedUsers.includes(user.id) && <Check className="w-3 h-3 text-white" />}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="py-8 text-center text-gray-500">
                            <User className="w-8 h-8 mx-auto mb-2 opacity-50" />
                            <p className="text-sm">No team members found</p>
                          </div>
                        )}
                      </div>
                    )}
      
                    {selectedUsers.length > 0 && (
                      <div className="space-y-2">
                        <p className="text-sm font-medium text-orange-600">
                          {selectedUsers.length} member{selectedUsers.length !== 1 ? "s" : ""} selected
                        </p>
                        <div className="flex flex-wrap gap-2 mt-2 max-h-20 overflow-y-auto">
                          {getSelectedUserNames().map((username, index) => {
                            const userId = selectedUsers[index]
                            return (
                              <div
                                key={userId}
                                className="flex items-center bg-orange-100 text-orange-700 text-xs font-medium pl-2.5 pr-1 py-1 rounded-full"
                              >
                                <span>{username}</span>
                                <button
                                  onClick={() => handleRemoveUser(userId)}
                                  className="ml-1.5 p-0.5 rounded-full hover:bg-orange-200 focus:outline-none"
                                  aria-label={`Remove ${username}`}
                                >
                                  <X className="w-3 h-3" />
                                </button>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    )}
                  </div>
      
                  <div className="flex gap-3 sm:gap-4 p-4 sm:p-6 border-t border-gray-100 bg-gray-50 rounded-b-3xl shrink-0">
                    <button
                      type="button"
                      onClick={() => setDialogOpen(false)}
                      className="flex-1 px-4 py-2.5 sm:py-3 text-gray-800 font-semibold bg-white rounded-xl border border-gray-300 hover:bg-gray-100 transition-all duration-200"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleAssignJob}
                      disabled={selectedUsers.length === 0 || assigningJob}
                      className="flex-1 px-4 py-2.5 sm:py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg shadow-orange-500/20 hover:shadow-xl hover:shadow-orange-500/30 disabled:shadow-none"
                    >
                      {assigningJob ? "Assigning..." : "Assign Job"}
                    </button>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
    </div>
  );
};

export default CompanyDetails;